module.exports = __webpack_public_path__ + "img/creaz_globale_ts.744fd407.png";